import { render, staticRenderFns } from "./create-event-data-screen.html?vue&type=template&id=56c6fd58&scoped=true&external"
import script from "./create-event-data-screen.js?vue&type=script&lang=js&external"
export * from "./create-event-data-screen.js?vue&type=script&lang=js&external"
import style0 from "./create-event-data-screen.scss?vue&type=style&index=0&id=56c6fd58&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6fd58",
  null
  
)

export default component.exports